export function fText(str) {
  if (str) {
    return str.charAt(0) + str.slice(1).toLowerCase();
  }
  return ''
}
